namespace GeniuzPOS.Common.Helpers {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class MemberFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 1) {
                return "<i class='fa fa-percent text-info'></i> " +
                       "<button class='btn btn-sm' style='background-color: #87CEEB; color: #4682B4; border: none;'>ส่วนลดจากราคาปกติท้ายบิล</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-tag text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #DAA520; border: none;'>ราคาขายช่องที่กำหนด</button>";
            }
            else if (chanel == 3) {
                return "<i class='fa fa-percent text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #DAA520; border: none;'>ส่วนลดจากราคาปกติในรายการ</button>";
            }

            else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    
   

}